<div class="workshop-admin-view-wrapper">
  <div class="workshop-admin-view-wrapper__header">
    <div class="workshop-admin-view-wrapper__header__title">
      <span class="wavw__header__title--name">{{ headingName }}</span>
      <span class="wavw__header__title--act">{{ subTitle }}</span>
    </div>
    <span class="wavw__header--value">{{ headerTypeLabel }}</span>
  </div>

  <div class="workshop-admin-view-wrapper__purpose">
    <div class="workshop-admin-view-wrapper__purpose--status">
      <span class="wavw__purpose--status-type">{{ type }}</span>
      <div class="wavw__purpose--status-date">
        <span class="wavw__purpose--status-date--text">
          {{ (isWorkshop ? workshopRes : workspSiteVisitRes)?.res?.workshopWeek || '--' }}
        </span>
        @if (
          (isWorkshop ? workshopRes : workspSiteVisitRes)?.res?.remainingDays != null &&
          (isWorkshop ? workshopRes : workspSiteVisitRes)?.res?.workshopWeek
        ) {
          <span class="wavw__purpose--status-date--remaining_days">
            {{ (isWorkshop ? workshopRes : workspSiteVisitRes)?.res?.remainingDays }} days from
            today
          </span>
        }
      </div>
    </div>
    <span
      class="status-badge"
      [class.status-badge--confirmed]="
        isConfirmedStatus(isWorkshop ? workshopRes : workspSiteVisitRes)
      "
      [class.status-badge--pending]="
        !isConfirmedStatus(isWorkshop ? workshopRes : workspSiteVisitRes)
      "
    >
      {{ statusLabel(isWorkshop ? workshopRes : workspSiteVisitRes) }}
    </span>
  </div>

  <div class="workshop-admin-view-wrapper-row">
    <span class="wavw-row__title">Griha Coordinator (Additional)</span>
    <div class="wavw-row-coordinator">
      <span class="wavw-row__rep-name">{{
        projectData?.coordinator?.name || workshopSiteVisit?.name || '--'
      }}</span>
    </div>
  </div>

  <div class="workshop-admin-view-wrapper-row">
    <span class="wavw-row__title">Client Representative</span>
    <div class="wavw-row-client-rep">
      <img
        class="wavw-row__person-icon"
        src="assets/images/workshop_group.svg"
        alt=""
      />
      <span class="wavw-row__rep-email">{{
        workshopSiteVisit.client_representative_email || '--'
      }}</span>
      <span class="wavw-row__rep-phone"
        >Phone No: {{ workshopSiteVisit.client_representative_phone || '--' }}</span
      >
    </div>
  </div>

  @if (isWorkshop) {
    <div class="workshop-admin-view-wrapper-row">
      <span class="wavw-row__title">Attendees</span>
      <div class="wavw-row-attendees">
        <app-meeting-attendees [attendees]="workshopSiteVisit.attendees"></app-meeting-attendees>
      </div>
    </div>
  }

  @if (isWorkshop) {
    <div class="workshop-admin-view-wrapper-upload">
      <span class="workshop-admin-view-wrapper-upload__title">Upload Check List</span>
      <div
        class="workshop-admin-view-wrapper-upload__box"
        fileDragDrop
        (fileDropped)="onFileDroppedCheckList($event)"
      >
        <input
          type="file"
          #fileDropRef
          id="fileDropRef"
          multiple
          (change)="checkListFileBrowseHandler($event)"
        />
        <div class="workshop-admin-view-wrapper-upload__box--icon">
          <img src="assets/images/upload_file.svg" alt="" />
        </div>
        <div class="workshop-admin-view-wrapper-upload__box--text">
          <span class="workshop-admin-view-wrapper-upload__box--text--1"
            >Drag &amp; drop your files here or</span
          >
          <span class="workshop-admin-view-wrapper-upload__box--text--2">
            <label
              class="workshop-admin-view-wrapper-upload__box--text--2"
              for="fileDropRef"
              >choose files</label
            >
          </span>
        </div>
        <span class="workshop-admin-view-wrapper-upload__max-size"
          >10 MB max file size</span
        >
      </div>
    </div>
  }

  @if (shouldShowChecklistDownloadView) {
    <div class="workshop-admin-view-wrapper__download-box">
      <span class="workshop-admin-view-wrapper__download-box__file_name">{{
        checkListFile?.name
      }}</span>
      <div class="workshop-admin-view-wrapper__download-box__action">
        <button [hidden]="true" type="button" class="wavw__download-box__action">
          <img src="/assets/images/download.svg" alt="" />
        </button>
        <button
          type="button"
          (click)="deleteFile('checklist')"
          class="wavw__download-box__action"
        >
          <img src="/assets/images/red_delete_icon.svg" alt="" />
        </button>
      </div>
    </div>
  }

  @if (isWorkshop) {
    <div class="workshop-admin-view-wrapper-upload">
      <span class="workshop-admin-view-wrapper-upload__title">Upload Attendees List</span>
      <div
        class="workshop-admin-view-wrapper-upload__box"
        fileDragDrop
        (filesChangeEmiter)="onFileDroppedAttendees($event)"
      >
        <input
          type="file"
          #fileDropRef1
          id="fileDropRef1"
          multiple
          (change)="attendeesFileBrowseHandler($event)"
        />
        <div class="workshop-admin-view-wrapper-upload__box--icon">
          <img src="assets/images/upload_file.svg" alt="" />
        </div>
        <div class="workshop-admin-view-wrapper-upload__box--text">
          <span class="workshop-admin-view-wrapper-upload__box--text--1"
            >Drag &amp; drop your files here or</span
          >
          <span class="workshop-admin-view-wrapper-upload__box--text--2">
            <label
              class="workshop-admin-view-wrapper-upload__box--text--2"
              for="fileDropRef1"
              >choose files</label
            >
          </span>
        </div>
        <span class="workshop-admin-view-wrapper-upload__max-size"
          >10 MB max file size</span
        >
      </div>
    </div>
  }

  @if (shouldShowAttendeesDownloadView) {
    <div class="workshop-admin-view-wrapper__download-box">
      <span class="workshop-admin-view-wrapper__download-box__file_name">{{
        attendeeFile?.name
      }}</span>
      <div class="workshop-admin-view-wrapper__download-box__action">
        <button [hidden]="true" type="button" class="wavw__download-box__action">
          <img src="/assets/images/download.svg" alt="" />
        </button>
        <button
          type="button"
          (click)="deleteFile('attendees')"
          class="wavw__download-box__action"
        >
          <img src="/assets/images/red_delete_icon.svg" alt="" />
        </button>
      </div>
    </div>
  }

  <div class="view-status-wrapper-bottom">
    <button
      type="button"
      class="view-status-wrapper-bottom__cancel"
      (click)="onCancelRequest('cancel')"
      mat-button
    >
      Cancel
    </button>
    <button
      type="button"
      class="view-status-wrapper-bottom__schedule"
      (click)="onClickScheduleRequest(workshopSiteVisit.status)"
      mat-button
    >
      {{ accept }}
    </button>
  </div>
</div>
